module.exports = __webpack_public_path__ + "img/product.ae1fec0f.jpg";